export const isValidFilesSize = (files: File[], limitMb: number) => {
  return (
    files.reduce((total, file) => total + file.size, 0) <= limitMb * 1000000
  );
};
